module.exports = __webpack_public_path__ + "nc_static/media/fileManagement.dc856741.svg";